function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagBF(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURQCiSgCoTfc9P/lFR/Q2OACuUPIvMfzNF/d0JpfDLUe3P9sLPeAAAAFtSURBVDjLzY0xbsJAEEXHN7CL7RHrA0TOBaKV5aRki1UEVQprxQGIDKkjOAGKlC5FxDUz83eNMTZWuuQj/fnz53mh+2nd0X8AdEwFXF84WgbmQUXRWnRIz0h2kZ5rrXEt2krEQIfL+WxR8sKkfgHk4zJlmDOSZAw7Wzhgy2P7QGVemrJkz9k5Ggk5Ik/DwKhMGwbA09U+AB4HQO2rGsL0h/dKxFslVcWATP5hVtVhDzLevX8h73HnLKqbTZgefV0DuNC62faLHrBugra3AH8IwP4mUOO+6f+Fu9SS77tes+gDjoHXKWDFwNsUsGx2g7+w1jrloj8336fGIToFpaSsVco6uD0drfv4UplC67hNCYcsVp9WZaujvMZPol1QxpMDmyT+WFZUStqUwspXFZPCJ60EGFEH3QDGXkjbkFwBaVR2DkknXgkfpGlCsiaJvCATWe6UEJt4qInXhDLZCb1IvseK3MXYtntf4+0f6QcWFxb5eqBfewAAAABJRU5ErkJggg==",
    alt: "BF"
  }, props));
}